import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ButtonProps } from "antd/lib";

const CbTableDeleteIconButton = ({
  style: externalStyles = {},
  className = "",
  ...props
}: ButtonProps) => {
  return (
    <Button
      {...props}
      type="text"
      title="Delete"
      size="small"
      className={`ca-delete-btn ${className}`}
      style={{ ...externalStyles, color: "red" }}
      icon={<DeleteOutlined />}
    />
  );
};

export default CbTableDeleteIconButton;

// <DeleteTwoTone
//   {...props}
//   className="ca-delete-btn cursor"
//   twoToneColor="#ff879d"
// />
